import { render, staticRenderFns } from "./ReadClockCard.vue?vue&type=template&id=2836cc76&scoped=true"
import script from "./ReadClockCard.vue?vue&type=script&lang=js"
export * from "./ReadClockCard.vue?vue&type=script&lang=js"
import style0 from "./ReadClockCard.vue?vue&type=style&index=0&id=2836cc76&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836cc76",
  null
  
)

export default component.exports